import { render, staticRenderFns } from "./Impressoras.vue?vue&type=template&id=e9527802&"
import script from "./Impressoras.vue?vue&type=script&lang=ts&"
export * from "./Impressoras.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports